import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { ListItem, ListOption } from '@/components/list-item';
import { TextInput } from '@/components/text-input';

interface Props {
  item: ListOption;
  onChange: (value: string) => void;
  value?: string;
}

export const TextInputListItem: React.FC<Props> = ({
  item,
  onChange,
  value,
}) => {
  const [styles] = useStyles();
  return (
    <ListItem
      item={item}
      renderMainContent={() => {
        return (
          <TextInput
            containerStyle={styles.inputContainer}
            onChangeText={onChange}
            placeholder={item.title}
            value={value ?? ''}
          />
        );
      }}
    />
  );
};

const useStyles = createStyles((theme) => ({
  inputContainer: {
    borderColor: theme.colors.stroke,
    flex: 1,
  },
}));
